import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CmsActivatedRouteSnapshot, OccEndpointsService, ProductSearchPage } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { catchError, first, map, switchMap } from 'rxjs/operators';
import { CategoryService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class SubCategoryGuard implements CanActivate {
  constructor(
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient,
    private router: Router,
    private categoryService: CategoryService
  ) {}

  canActivate(route: CmsActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (route.url[route.url.length - 2].path === 'c') {
      return this.canActivateSubCategory();
    } else {
      return this.canActivateSisSubCategory();
    }
  }

  private canActivateSubCategory(): Observable<boolean | UrlTree> {
    return this.categoryService.getCurrentCategory().pipe(
      first((category) => !!category),
      catchError(() => of(undefined)),
      switchMap((category) => {
        if (category === undefined) {
          return of(undefined);
        }
        if (category.subCategories?.length > 0) {
          return of(undefined);
        } else {
          const query = ':default:isMarketing:true:allCategories:' + category.code;
          const searchUrl = this.occEndpointsService.buildUrl('productMinimalSearch', {
            queryParams: { query, pageSize: '1' }
          });
          return this.http.get<ProductSearchPage>(searchUrl);
        }
      }),
      map((searchPage: ProductSearchPage | undefined) => {
        if (
          searchPage?.pagination?.totalResults === 1 &&
          (searchPage.products[0].indexedBundles === undefined || searchPage.products[0].indexedBundles.length === 0)
        ) {
          return this.router.parseUrl(searchPage.products[0].url);
        } else {
          return true;
        }
      })
    );
  }

  private canActivateSisSubCategory(): Observable<boolean | UrlTree> {
    return this.categoryService.getCurrentCategory().pipe(
      first((category) => !!category),
      map((category) => {
        if (category.subCategories?.length > 0) {
          return true;
        } else {
          if (
            category.products?.length === 1 &&
            (category.products[0].indexedBundles === undefined || category.products[0].indexedBundles.length === 0)
          ) {
            return this.router.parseUrl(category.products[0].url);
          } else {
            return true;
          }
        }
      })
    );
  }
}
